// extracted by mini-css-extract-plugin
module.exports = {"Image":"Image_Image__1br15"};